import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/** Set true (via an HttpContext passed on the request) to opt a call out of the app-wide
 *  loading overlay — for a component that already shows its own local/inline loading state
 *  and would otherwise double up with a full-page dim on top of it (e.g. Package Module
 *  switching plans, whose table already dims itself while the next plan's rows load). */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (req.context.get(SKIP_GLOBAL_LOADER)) return next(req);

  const loading = inject(LoadingService);
  loading.show();

  return next(req).pipe(
    finalize(() => loading.hide())
  );
};
